// Copyright 2020 Sorama B.V.

import { bindable, customElement } from "aurelia-framework";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { Instance } from "flatpickr/dist/types/instance";

@customElement("date-picker")
export class DatePicker {
    @bindable
    public startDate: Date;

    @bindable
    public endDate: Date;

    private dateElement: HTMLDivElement;
    private picker: Instance;

    constructor() {}

    public bind(): void {}

    public attached(): void {
        this.picker = flatpickr(this.dateElement, {
            mode: "range",
            onChange: () => {
                if (this.picker && this.picker.selectedDates && this.picker.selectedDates.length == 2) {
                    this.startDate = this.picker.selectedDates[0];
                    this.endDate = this.picker.selectedDates[1];
                }
            },
            defaultDate: this.endDate && this.startDate ? [this.startDate, this.endDate] : undefined,
        });
    }

    public startDateChanged(): void {
        if (!this.picker.isOpen) {
            this.picker.setDate([this.startDate, this.endDate]);
        }
    }

    public endDateChanged(): void {
        if (!this.picker.isOpen) {
            this.picker.setDate([this.startDate, this.endDate]);
        }
    }

    protected clear(event: Event): void {
        if (this.picker) {
            this.picker.clear();
        }

        if (event) {
            event.stopPropagation();
        }

        this.endDate = undefined;
        this.startDate = undefined;
    }
}
